import type { RegistrationState, WelcomeWithInitialLimitStatus } from './reducer'
import type { RegistrationData } from '../../model/registration'
import { useAppSelector } from '../hooks'
import {
  registrationSelector,
  registrationDataSelector,
  registrationConsumerNameSelector,
  registrationConsumerSurnameSelector,
  registrationConsumerGivenNameSelector,
  registrationConsumerMobileSelector,
  registrationConsumerEmailSelector,
  registrationConsumerDateOfBirthSelector,
  registrationConsumerAddressSelector,
  welcomeWithInitialLimitStatusSelector,
} from './selectors'
import { InputAddressData } from '@afterpaytouch/core'

export { registrationSelector, registrationDataSelector } from './selectors'

export const useRegistration = (): RegistrationState => useAppSelector(registrationSelector)

export const useRegistrationData = (): RegistrationData | undefined => useAppSelector(registrationDataSelector)

export const useRegistrationConsumerName = (): string => useAppSelector(registrationConsumerNameSelector)

export const useRegistrationConsumerGivenName = (): string => useAppSelector(registrationConsumerGivenNameSelector)

export const useRegistrationConsumerSurname = (): string => useAppSelector(registrationConsumerSurnameSelector)

export const useRegistrationConsumerMobile = (): string => useAppSelector(registrationConsumerMobileSelector)

export const useRegistrationConsumerEmail = (): string => useAppSelector(registrationConsumerEmailSelector)

export const useRegistrationConsumerDateOfBirth = (): string => useAppSelector(registrationConsumerDateOfBirthSelector)

export const useRegistrationConsumerAddress = (): InputAddressData => useAppSelector(registrationConsumerAddressSelector)

export const useWelcomeWithInitialLimitStatus = (): WelcomeWithInitialLimitStatus => useAppSelector(welcomeWithInitialLimitStatusSelector)
